
import React, { Component } from 'react'
import { BaseCarouselP, PrihodCarouselP, RashodCarouselP } from './P_Carousel';
import "./Payment.css"

export default class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PAYMENT: [],
      oplata: [],
      prihod: [],
      rashod: [],
    };
  }

  componentDidMount() {
    this.setState({
      PAYMENT: this.props.PAYMENT,
    });
    setTimeout(() => {
      this.oplata();
      this.prihod();
      this.rashod();
    }
      , 0)
  }

  oplata() {
    const Payment = this.state.PAYMENT;
    let oplata = [];
    if (Payment) {
      if (Payment[0].length > 1) {

        oplata.push(
          <div className="Orders_mob_container">
            <div className="Payment_mob_header">Оплата за контракт</div>
            <div className="Orders_mob_body">
              <div className="Oplata_mob_left">
                <div>Уч. год</div>
                <div>Курс</div>
                <div>Контракт</div>
                <div>Оплатил</div>
                <div>Долг</div>
                <div>Спец.</div>
              </div>
              <div><BaseCarouselP payment={Payment[0]} /></div>
            </div>
          </div>
        );
        this.setState({ oplata });
      }
      else if (Payment[0][0]) {
        oplata.push(
          <div className="Orders_mob_container">
            <div className="Payment_mob_header">Оплата за контракт</div>
            <div className="Orders_mob_body">
              <div className="Oplata_mob_left">
                <div>Уч. год</div>
                <div>Курс</div>
                <div>Контракт</div>
                <div>Оплатил</div>
                <div>Долг</div>
                <div>Спец.</div>
              </div>
              <div className="data_rows">
                <div><p>{Payment[0][0].years1}</p> </div>
                <div><p>{Payment[0][0].id_rate}</p></div>
                <div><p>{Payment[0][0].smeta} сом</p></div>
                <div><p>{Payment[0][0].sum_opl} сом</p></div>
                <div><p>{Payment[0][0].dolg} сом</p></div>
                <div><p>{Payment[0][0].spec1}</p></div>
              </div>
            </div>
          </div>
        )
        this.setState({ oplata });
      }
    }
  }

  prihod() {
    const Payment = this.state.PAYMENT;
    let prihod = [];
    if (Payment) {
      if (Payment[1].length > 1) {

        prihod.push(
          <div className="Orders_mob_container">
            <div className="Prihod_mob_header">Приход</div>
            <div className="Orders_mob_body">
              <div className="Prihod_mob_left">
                <div>Уч. год</div>
                <div>Оплата (сом)</div>
                <div>Дата</div>
                <div>№ ордера.</div>
                <div>Вид оплаты</div>
                <div>Спец.</div>
                <div>Целевое назнач.</div>
              </div>
              <div><PrihodCarouselP payment={Payment[1]} /></div>
            </div>
          </div>
        );
        this.setState({ prihod });
      }
      else if (Payment[1][0]) {
        prihod.push(
          <div className="Orders_mob_container">
            <div className="Prihod_mob_header">Приход</div>
            <div className="Orders_mob_body">
              <div className="Prihod_mob_left">
                <div>Уч. год</div>
                <div>Оплата (сом)</div>
                <div>Дата</div>
                <div>№ ордера.</div>
                <div>Вид оплаты</div>
                <div>Спец.</div>
                <div>Целевое назнач.</div>
              </div>
              <div className="data_rows">
                <div><p>{Payment[1][0].years2}     </p></div>
                <div><p>{Payment[1][0].prihod}     </p></div>
                <div><p>{Payment[1][0].dates2}     </p></div>
                <div><p>{Payment[1][0].orders2}    </p></div>
                <div><p>{Payment[1][0].vid_opl2}   </p></div>
                <div><p>{Payment[1][0].spec2}   </p></div>
                <div><p>{Payment[1][0].uslugi2}    </p></div>
              </div>
            </div>
          </div>
        )
        this.setState({ prihod });
      }
    }
  }

  rashod() {
    const Payment = this.state.PAYMENT;
    let rashod = [];
    if (Payment) {
      if (Payment[2].length > 1) {


        rashod.push(
          <div className="Orders_mob_container">
            <div className="Rashod_mob_header">Расход</div>
            <div className="Orders_mob_body">
              <div className="Rashod_mob_left">
                <div>Уч. год</div>
                <div>Расход (сом)</div>
                <div>Дата</div>
                <div>№ ордера.</div>
                <div>Вид оплаты</div>
                <div>Целевое назнач.</div>
              </div>
              <div><RashodCarouselP payment={Payment[2]} /></div>
            </div>
          </div>
        );
        this.setState({ rashod });

      }
      else if (Payment[2][0]) {
        rashod.push(
          <div className="Orders_mob_container">
            <div className="Rashod_mob_header">Расход</div>
            <div className="Orders_mob_body">
              <div className="Rashod_mob_left">
                <div>Уч. год</div>
                <div>Расход (сом)</div>
                <div>Дата</div>
                <div>№ ордера.</div>
                <div>Вид оплаты</div>
                <div>Целевое назнач.</div>
              </div>
              <div className="data_rows">

                <div><p>{Payment[2][0].years3}     </p></div>
                <div><p>{Payment[2][0].rashod}     </p></div>
                <div><p>{Payment[2][0].dates3}     </p></div>
                <div><p>{Payment[2][0].orders3}    </p></div>
                <div><p>{Payment[2][0].vid_opl3}   </p></div>
                <div><p>{Payment[2][0].uslugi3}    </p></div>

              </div>
            </div>
          </div>
        )
        this.setState({ rashod });
      }
    }



  }

  render() {
    const Payment = this.state.PAYMENT;

    let show = [];
    if (Payment) {
      if (Payment.length) {
        show.push(
          <div>
            {this.state.oplata}
            {this.state.prihod}
            {this.state.rashod}
          </div>
        )
      }
    }
    else {
      show.push(
              <p class="animate__animated animate__bounce">Нет данных</p>
      )
    }

    return (
      <div>
        {show}
      </div>
    )

  }
}
